module.exports = __webpack_public_path__ + "img/logo_adwg.1f9868de.svg";